module.exports = __webpack_public_path__ + "static/media/7.0701c91b.jpg";